export default {
  getAllBanner: {},
  selectedBanner: {},
  getMasterCampaign: {},
  campaignPartner: {},
  campaignHome: {},
  selectedcampaignHome: {},
  selectedPartner: {},
  aboutcampaignBanner: {},
  selectedcampaignBanner: {},
  campaignReference: {},
  selectedcampaignReference: {},
};
